import { get } from '~/utils';
// 二级路径
export const getBasePath = () => get(window.jdy_config, 'base_path', '');
